/* istanbul ignore file*/
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { SitefinityContentService } from 'src/app/core/services/settings/sitefinity-content.service';
import { INavigationItem } from 'src/app/model/sitefinity/INavigationItem';
import { filter, takeUntil } from 'rxjs/operators';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { AsyncSubject, combineLatest, Subject } from 'rxjs';
import { ClaimsService } from 'src/app/core/services/claims.service';
import { ICategory } from 'src/app/model/device-inventory/ICategory';
import { ISSPCategory } from 'src/app/model/claims/ISSPCategoryMapping';
import { IFileAClaim } from 'src/app/model/sitefinity/IFileAClaim';
import { FeatureGuard } from '../../../../core/guards/feature.guard';
import { ISelectedContract, LoggedInUserSettings } from '../../../../core/services/settings/logged-in-user-settings';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { CHAT, CHATGROUP, CLAIMSGROUP, FILEACLAIM } from '../../../../core/constants/feature-key.constants';
import { IPromoSlot } from 'src/app/model/sitefinity/IDashboard';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from 'src/app/core/services/utility.service';
import { IDeviceType } from 'src/app/model/claims/IDeviceType';
import { ContractGuard } from 'src/app/core/guards/contract.guard';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { IFormField } from 'src/app/model/sitefinity/IFormField';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { GSSPAuthenticationService } from 'src/app/core/services/gssp-authentication.service';
import { ElitaChildCertificateResponseDto } from 'src/app/model/account/elita-child-certificate-response.dto';
import { AccountService } from 'src/app/core/services/account.service';
import { ADPResourceService } from 'digital-core';
import { GlobalModalWindowComponent } from 'src/app/shared/components/global-modal-window/global-modal-window.component';
import { GlobalModalWindowService } from 'src/app/core/services/global-modal-window.service';
import { AsappChatService } from '../../../../core/services/asapp-chat.service';

export interface IDeviceInfo {
  title: string;
}

export interface IDeviceInfoWithError extends IDeviceInfo {
  errorMessage: string;
}

export interface IDeviceInfoDropdown extends IDeviceInfo {
  placeholder: string;
  options: any[];
}

export interface IRegisteredDevice {
  modelIdentifier: string;
  certificateNumber: string;
  dealerCode: string;
  deviceTypeCode: string;
  itemDescription: string;
  manufacturer: string;
  model: string;
  purchasePrice: number;
  purchasedDate: Date;
  registeredItemName: string;
  registrationDate: Date;
  serialNumber: string;
}

/**
 * @deprecated This is the old file a claim experience. We no longer use this. This is still in use
 * for the older portals (old TMO, DTE, PGH Organic, etc...). This component is in maintenance mode
 * so only touch when absolutely necessary. The newer way of doing file a claim is through the
 * "claims and support" pages/flow.
 */
@Component({
  selector: 'pgh-claims-flow',
  templateUrl: './claims-flow.component.html',
  styleUrls: ['./claims-flow.component.scss'],
})
export class ClaimsFlowComponent implements OnInit, OnDestroy {
  readonly OKTA_TOKEN_STORAGE = 'okta-token-storage';

  public isMobilePlanActive: boolean = false;
  fileAClaimPage: IFileAClaim;
  activeStep = 1;
  negativePath = false;
  private destroy$ = new Subject<boolean>();
  sspCategories: ISSPCategory[];
  claimEligible: boolean = false;
  displayClaimDate: string;
  waitingPeriod: number;

  categoriesDropdown: IFormField;
  // categoriesDropdownMessage: IDeviceInfoWithError;
  subCategoriesDropdown: IFormField;
  brandsSearchBox: IFormField;
  modelTextBox: IFormField;

  deviceNameTextBox: IFormField;
  serialNumberTextBox: IFormField;
  purchasePriceTextBox: IFormField;
  purchaseDateTextBox: IFormField;

  userClaims: UserClaims;
  contractNum: string;
  zipCode: string;
  viewClaimsHistoryLink: INavigationItem;
  accountClaimsHeadingText: string = 'Account Claims';
  claimsHeadingText: string = 'Claims Pre-Qualification';
  claimsSubheadingText: string; // = 'To get started with the claim process, please answer the following questions.';
  promoSlot: IPromoSlot = null;
  isClaimsHistoryAndStatusEnabled: boolean = false;
  isTechServicesChatEnabled: boolean = false;
  searchClaimsUrl: string;
  deviceTypes: IDeviceType[];

  isLoaded: boolean = false;
  secondaryUserDescription: string;
  @Output() letsChatClicked = new EventEmitter();

  isGSSP = false;
  dealerCode: string;
  masterCertificateNumber: string;
  coverageTypeCode: string;
  deviceTypeCategories: ICategory[] = [];
  isActive: boolean;
  categoriesDropdownOptions: ICategory[];
  redirectUrl: string;
  heading: string;
  description: any;
  startClaimText: string;
  childCertNumber$ = new AsyncSubject<ElitaChildCertificateResponseDto>(); // Only subscribe to this when is GSSP is true.

  constructor(
    private sitefinityContentService: SitefinityContentService, // Note: we have decided to not refactor this component to use the new Sitefinity structure. Only the old clients (old TMO, DTE, PGH Organic, etc...) are using this component and any new client created will NOT use this component. So there is no risk from not refactoring it.
    private deviceInventoryService: DeviceInventoryService,
    private claimsService: ClaimsService,
    private loggedInUserSettings: LoggedInUserSettings,
    private featureGuard: FeatureGuard,
    public route: ActivatedRoute,
    private utilityService: UtilityService,
    private matDialog: MatDialog,
    private googleAnalyticsService: GoogleAnalyticsService,
    private contractGuard: ContractGuard,
    private gsspAuthService: GSSPAuthenticationService,
    private domSanitizer: DomSanitizer,
    private accountService: AccountService,
    public resourceService: ADPResourceService,
    private globalModalWindowService: GlobalModalWindowService,
    private asappChatService: AsappChatService
  ) {
    this.utilityService.log('Starting to load claim page');

    this.fileAClaimPage = this.sitefinityContentService?.getSettings()?.FileAClaimPage;
    this.isMobilePlanActive = this.resourceService.isPortalSettingTrue('Global_CTC_IsMobileplanActive');
  }

  claimHistoryAndStatus() {
    if (this.isGSSP) {
      if (this.masterCertificateNumber && this.masterCertificateNumber.length > 0) {
        const childCertificateNumbers: [string] = [this.masterCertificateNumber + '-1'];
        this.gsspAuthService.postGenerateGSSPToken(this.dealerCode, this.masterCertificateNumber, childCertificateNumbers, null).subscribe({
          next: (gsspAuthToken: any) => {
            if (gsspAuthToken && gsspAuthToken.length > 0) {
              this.redirectUrl = `${this.searchClaimsUrl}?accessToken=${gsspAuthToken}`;
              this.redirectUrl = this.domSanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
              window.open(this.redirectUrl, '_self');
            } else {
              this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_InvalidGsspAuthToken_Title', 'GetGsspAuthToken');
            }
          },
        });
      } else {
        this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_MissingMasterCertificate_Title', 'GetGsspAuthToken');
      }
    } else {
      const tokens = JSON.parse(localStorage.getItem(this.OKTA_TOKEN_STORAGE));
      const accessToken =
        tokens.access_token && tokens.access_token.accessToken ? tokens.access_token.accessToken : tokens?.accessToken?.accessToken;
      const hashedQuery = btoa(`cn=${this.contractNum}&zip=${this.zipCode}`);
      if (accessToken.indexOf(' ') >= 0) {
        console.log('invalid token');
      } else {
        this.redirectUrl = `${this.searchClaimsUrl}?q=${hashedQuery}&token=${accessToken}`;
        this.redirectUrl = this.domSanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
        window.open(this.redirectUrl, '_blank');
      }
    }
  }

  ngOnInit() {
    this.categoriesDropdown = this.fileAClaimPage?.gsspFileAClaimFields?.filter((x) => x.name.toLowerCase().trim() === 'category')?.[0];
    this.subCategoriesDropdown = this.fileAClaimPage?.gsspFileAClaimFields?.filter(
      (x) => x.name.toLowerCase().trim() === 'subcategory'
    )?.[0];
    this.brandsSearchBox = this.fileAClaimPage?.gsspFileAClaimFields?.filter((x) => x.name.toLowerCase().trim() === 'brandsearch')?.[0];
    this.modelTextBox = this.fileAClaimPage?.gsspFileAClaimFields?.filter((x) => x.name.toLowerCase().trim() === 'model')?.[0];
    this.deviceNameTextBox = this.fileAClaimPage?.gsspFileAClaimFields?.filter((x) => x.name.toLowerCase().trim() === 'devicename')?.[0];
    this.serialNumberTextBox = this.fileAClaimPage?.gsspFileAClaimFields?.filter(
      (x) => x.name.toLowerCase().trim() === 'serialnumber'
    )?.[0];
    this.purchasePriceTextBox = this.fileAClaimPage?.gsspFileAClaimFields?.filter(
      (x) => x.name.toLowerCase().trim() === 'purchaseprice'
    )?.[0];
    this.purchaseDateTextBox = this.fileAClaimPage?.gsspFileAClaimFields?.filter(
      (x) => x.name.toLowerCase().trim() === 'purchasedate'
    )?.[0];

    this.accountClaimsHeadingText = this.fileAClaimPage?.headingTitle;
    this.claimsHeadingText = this.fileAClaimPage?.heading;
    this.claimsSubheadingText = this.fileAClaimPage?.subheading;
    this.viewClaimsHistoryLink = this.fileAClaimPage?.claimsHistoryAndStatusLink?.[0];
    this.secondaryUserDescription = this.fileAClaimPage?.secondaryUserDescription;
    this.promoSlot = this.fileAClaimPage?.promoSlot?.[0];
    this.waitingPeriod = this.fileAClaimPage?.facWaitingPeriod?.[0]?.waitingPeriodInDays;
    this.heading = this.fileAClaimPage?.facWaitingPeriod?.[0]?.heading;
    this.description = this.domSanitizer.bypassSecurityTrustHtml(this.fileAClaimPage?.facWaitingPeriod?.[0]?.description);
    this.startClaimText = this.fileAClaimPage?.facWaitingPeriod?.[0]?.startClaimText;

    const joined$ = combineLatest([
      this.deviceInventoryService.getDeviceInventoryCategories(),
      this.claimsService.loadSSPMapping(),
      this.claimsService.getExtraCategories(),
      this.loggedInUserSettings.$selectedContract,
      this.loggedInUserSettings.$userClaims,
    ]).pipe(
      filter(([a, b, c, d, e]) => a !== null && b !== null && d !== null && e !== null),
      takeUntil(this.destroy$)
    );

    joined$.subscribe(
      ([categories, sspCategories, extraCategories, selectedContract, userClaims]: [
        ICategory[],
        ISSPCategory[],
        ICategory[],
        ISelectedContract,
        UserClaims,
      ]) => {
        this.isActive = this.contractGuard.activateGuard(selectedContract, false);
        this.isGSSP = selectedContract.useGSSPClaims;
        this.masterCertificateNumber = selectedContract?.dealerId + selectedContract?.id;
        this.dealerCode = selectedContract.dealerId;
        this.coverageTypeCode = 'AD';

        if (this.waitingPeriod > 0) {
          const contractStartDate = new Date(selectedContract.startDate);
          const claimStartDate = new Date(selectedContract.startDate);
          const todaysdate = new Date();
          claimStartDate.setDate(contractStartDate.getDate() + this.waitingPeriod);
          this.claimEligible = todaysdate.getTime() > claimStartDate.getTime();
          this.displayClaimDate =
            (claimStartDate.getMonth() > 8 ? claimStartDate.getMonth() + 1 : '0' + (claimStartDate.getMonth() + 1)) +
            '/' +
            (claimStartDate.getDate() > 9 ? claimStartDate.getDate() : '0' + claimStartDate.getDate()) +
            '/' +
            claimStartDate.getFullYear();
        } else {
          this.claimEligible = true;
        }

        if (this.isGSSP) {
          // Pre-fetch the child certificate number
          const childCertificateNumber = this.masterCertificateNumber + '-1';
          this.accountService
            .getElitaChildCertificateNumber(this.masterCertificateNumber, childCertificateNumber, this.dealerCode)
            .subscribe(this.childCertNumber$);

          this.claimsService
            .getDeviceTypesList(this.dealerCode, this.masterCertificateNumber, this.coverageTypeCode)
            .subscribe((devices) => {
              this.deviceTypes = devices;
              this.categoriesDropdownOptions = this.mapDeviceTypesToCategory(this.deviceTypes);
            });
        }
        // Add extra categories, this is a workaround and needs to be reworked in the future
        else if (extraCategories.length > 0) {
          const sortedMergedCategories = categories
            .concat(extraCategories)
            .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
          this.categoriesDropdownOptions = sortedMergedCategories;
        } else {
          this.categoriesDropdownOptions = categories;
        }

        this.sspCategories = sspCategories;

        this.userClaims = userClaims;
        this.zipCode = selectedContract?.zipCode;
        this.contractNum =
          selectedContract && selectedContract?.members && selectedContract?.members.length
            ? selectedContract?.members[0].contractNumber
            : '';

        this.isTechServicesChatEnabled =
          this.loggedInUserSettings.isFeatureEnabled(selectedContract?.dealerId, CHATGROUP) &&
          this.loggedInUserSettings.isFeatureEnabled(selectedContract?.dealerId, CHAT);
        let isEnabled = this.loggedInUserSettings.isFeatureEnabled(selectedContract?.dealerId, CLAIMSGROUP);

        if (!this.loggedInUserSettings.isFeatureEnabled(selectedContract?.dealerId, FILEACLAIM)) {
          isEnabled = false;
        }

        if (isEnabled) {
          this.isLoaded = true;
        } else {
          this.featureGuard.canActivate(selectedContract?.dealerId, CLAIMSGROUP, isEnabled);
        }
        this.utilityService.log('Claim page load completed.');
      }
    );

    this.searchClaimsUrl = this.resourceService.getPortalSetting('URL_ClaimsPortal').Value;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.childCertNumber$.complete();
  }

  changeStep(answer: number, question: number) {
    if (this.activeStep !== question) {
      this.activeStep = question;
    } else if (answer === 0) {
      this.activeStep = this.activeStep === 1 ? 2 : 3;
    }
    this.negativePath = !!answer;
  }

  letsChat() {
    this.letsChatClicked.emit();

    const rnWindow = window as any;
    if (rnWindow.ReactNativeWebView) {
      const message = JSON.stringify({ action: 'openChat', args: {} });
      rnWindow.ReactNativeWebView.postMessage(message);
    }

    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.route, this.asappChatService);
    chatHandler.openChatInterface();
  }

  mapDeviceTypesToCategory(deviceTypesList: IDeviceType[]) {
    const deviceTypeCategories: ICategory[] = [];
    if (deviceTypesList !== undefined && deviceTypesList.length > 0) {
      deviceTypesList.forEach((deviceType) => {
        const devCategoryItem: ICategory = {
          deviceCount: '',
          deviceValue: '',
          averagePrice: 0,
          categoryId: deviceType.deviceTypeCode,
          categoryType: '',
          createdAt: '',
          defaults: '',
          hasAccidentalDamage: '',
          hasMechanicalDamage: '',
          imageReference: '',
          isActive: '',
          lastModified: '',
          name: deviceType.deviceTypeDescription,
          singleValue: '',
        };
        deviceTypeCategories.push(devCategoryItem);
      });
    }
    return deviceTypeCategories;
  }
}
